import React, { useCallback, useEffect, useState } from 'react';
import { Button, Data, Dialog, DialogProps, Form, FormProps, Input, MessagePlugin, Select, SubmitContext } from 'tdesign-react';

import { IFormItemProps } from '@/components';
import UploadFile from '@/material/form-upload/file';
import { fetchKnowledgeList, postKnowledge } from '@/services/bot';

import styles from './index.module.less';


interface IFormArrayProps {
  fieldsConfig: IFormItemProps[];
  form: any;
  repeatConfig?: {
    [key: string]: IFormItemProps[];
  };
}

const { FormItem } = Form;

export const CustomUploadSelect: React.FC<
{
  fieldname: string;
  config: any;
  errors: { [key: string]: any };
  getFieldDecorator: any;
  value: any;
  max: number;
  onChange: (value: string[]) => {};
  disabled?: boolean;
  modal: {
    text: string;
    fieldsConfig?: IFormItemProps[];
    modalConfig?: DialogProps;
    modalTitle?: { title: string; subTitle: string };
  };
} & IFormArrayProps
> = (props) => {
  const {
    value = [],
    onChange,
    disabled = false,
    modal = {
      fieldsConfig: [],
      modalConfig: {},
      modalTitle: { title: '', subTitle: '' },
    },
  } = props;

  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState<{ value: string, label: string }[]>([]);

  const [form] = Form.useForm();

  const loadKnowledges = useCallback(async () => {
    const res = await fetchKnowledgeList();
    if (res) {
      setOptions(res.map(item => ({ label: item.name, value: item.id })));
    }
  }, []);

  const handleFocus = useCallback(() => {
    loadKnowledges();
  }, []);

  const handleClick1 = useCallback(() => {
    setVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  const handleConfirm = useCallback(() => {
    form.submit();
  }, [form]);

  const handleSubmit: FormProps['onSubmit'] = useCallback((context: SubmitContext<Data>) => {
    if (context.validateResult === true) {
      const val = (form.getFieldsValue(true));
      postKnowledge({ knowledgeName: val?.knowledgeName || '', contentUrl: val.contentUrl?.url?.url || '' })
        .then(() => {
          loadKnowledges();
          MessagePlugin.success('上传成功');
        })
        .catch((err) => {
          MessagePlugin.error(err.message);
        })
        .finally(() => {
          form.reset();
          setVisible(false);
        });
    }
  }, [form]);

  useEffect(() => {
    loadKnowledges();
  }, []);

  return (
    <div className={styles.arrayWrap}>
      <Select
        disabled={disabled}
        placeholder='请选择知识库'
        options={options}
        multiple
        filterable
        filter={(filterWord, option) => (option?.label || '').includes(filterWord)}
        value={value}
        onChange={onChange as any}
        onFocus={handleFocus}
      />
      <Button className={styles.button} disabled={disabled}
        theme='default' onClick={handleClick1}>
        上传知识库
      </Button>
      <Dialog
        onClose={handleClose}
        visible={visible}
        destroyOnClose
        header={modal.modalTitle?.title || ''}
        onConfirm={handleConfirm}
      >
        <Form form={form} style={{ paddingTop: 24 }} onSubmit={handleSubmit} >
          <FormItem
            label={<div style={{ display: 'inline-block', marginTop: 8 }}>名称</div>}
            name='knowledgeName' requiredMark rules={[{ required: true, message: '知识库名称必填' }]}>
            <Input />
          </FormItem>
          <FormItem label={<div style={{ display: 'inline-block', marginTop: 8 }}>知识库文件</div>} name='contentUrl' requiredMark rules={[{ required: true, message: '请上传知识库文件' }]}>
            <UploadFile limit={{ fileType: ['.txt'] }} value={{}} onChange={() => { }} />
          </FormItem>
        </Form>
      </Dialog>
    </div>
  );
};
